import { render, staticRenderFns } from "./blog-details-left-sidebar.vue?vue&type=template&id=b9009962&"
import script from "./blog-details-left-sidebar.vue?vue&type=script&lang=js&"
export * from "./blog-details-left-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports